module.exports = __webpack_public_path__ + "static/media/japan.7aef6ea4.jpg";